import { Link, useLocation } from 'react-router-dom';
import { type ReactNode } from 'react';
import { useAuth } from '../auth-context';

export default function Layout({ children }: { children: ReactNode }) {
  const { profile, logout } = useAuth();
  const location = useLocation();

  return (
    <div className="app-shell">
      <header className="app-header">
        <div className="app-header__inner">
          <Link to="/checklists" className="app-header__brand">
            <span className="app-header__logo">QC</span>
            <span className="app-header__title">Hub</span>
          </Link>

          <nav className="app-header__nav">
            <Link
              to="/checklists"
              className={`app-header__navlink ${location.pathname.startsWith('/checklists') ? 'is-active' : ''}`}
            >
              Checklists
            </Link>
            <Link
              to="/failures"
              className={`app-header__navlink ${location.pathname.startsWith('/failures') ? 'is-active' : ''}`}
            >
              Failures
            </Link>
            <Link
              to="/training"
              className={`app-header__navlink ${location.pathname.startsWith('/training') ? 'is-active' : ''}`}
            >
              Training
            </Link>
          </nav>

          <div className="app-header__user">
            {profile && (
              <>
                <span className="app-header__username">{profile.displayName}</span>
                <span className={`app-header__role app-header__role--${profile.role}`}>
                  {profile.role === 'admin' ? 'Admin' : 'QC'}
                </span>
              </>
            )}
            <button className="app-header__logout" onClick={logout}>
              Sign out
            </button>
          </div>
        </div>
      </header>

      <main className="app-main">{children}</main>
    </div>
  );
}
